import { render, staticRenderFns } from "./KebabMenu.vue?vue&type=template&id=52627420&scoped=true"
import script from "./KebabMenu.vue?vue&type=script&lang=js"
export * from "./KebabMenu.vue?vue&type=script&lang=js"
import style0 from "./KebabMenu.vue?vue&type=style&index=0&id=52627420&prod&lang=css"
import style1 from "./KebabMenu.vue?vue&type=style&index=1&id=52627420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52627420",
  null
  
)

export default component.exports